import React from 'react';

type SkeletonAnimation = 'pulse' | 'wave' | 'none';

interface SkeletonFormProps {
  fieldCount?: number;
  hasButton?: boolean;
  animation?: SkeletonAnimation;
}

export const SkeletonForm: React.FC<SkeletonFormProps> = ({
  fieldCount = 4,
  hasButton = true,
  animation = 'wave',
}) => {
  const fieldIndexes = Array.from({ length: fieldCount });

  return (
    <div className="skeleton-form">
      {fieldIndexes.map((_, index) => (
        <div key={`field-${index}`} className="skeleton-form-field">
          <div className="skeleton skeleton-form-label" />
          <div className="skeleton skeleton-form-input" />
        </div>
      ))}
      {hasButton && <div className="skeleton skeleton-form-button" />}
    </div>
  );
};

export default SkeletonForm;
